import sileo from 'sileo';

const CompanyPermissionsList = new sileo.Model('hqzen', 'company-permissions-list');

const CompensationSetting = new sileo.Model('hqzen', 'company-settings-view-compensation');
const WorkScheduleSetting = new sileo.Model('hqzen', 'company-settings-view-work-schedule');

const PermissionUsers = new sileo.Model('hqzen', 'permission-users-list');
const PermissionTabsCount = new sileo.Model('hqzen', 'permission-tabs-count');
const PermissionTabUsers = new sileo.Model('hqzen', 'tab-users');

const AccountabilityPermission = new sileo.Model('hqzen', 'access-accountability-permission');
const GrantorRevokeUsersPermission = new sileo.Model('hqzen', 'grant-or-revoke-users-permission');

const actions = {
    fetchCompanyPermissions(context, filters) {
        return CompanyPermissionsList.objects.filter(filters);
    },

    fetchPermissionTabUsers(context, filters) {
        return PermissionTabUsers.objects.filter(filters);
    },

    updateGrantorRevokeUsersPermission(context, data) {
        const form = new FormData();
        if (data.user_profile_pks) {
            data.user_profile_pks = JSON.stringify(data.user_profile_pks);
        }

        for (let key in data) {
            form.append(key, data[key]);
        }

        return GrantorRevokeUsersPermission.objects.update({
            'permission_id': data.permission_id
        }, form);
    },

    fetchGrantedCompensationSettings(context, filters) {
        return CompensationSetting.objects.filter(filters);
    },

    updateCompensationSettings(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return CompensationSetting.objects.update({ 'company_id': data.company_id }, form);
    },

    fetchGrantedWorkScheduleSettings(context, filters) {
        return WorkScheduleSetting.objects.filter(filters);
    },

    updateWorkScheduleSettings(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return WorkScheduleSetting.objects.update({ 'company_id': data.company_id }, form);
    },

    fetchGrantedAccountabilityPermission(context, filters) {
        return AccountabilityPermission.objects.filter(filters);
    },

    fetchPermissionUsers(context, filters) {
        return PermissionUsers.objects.filter(filters);
    },

    fetchPermissionTabsCount(context, filters) {
        return PermissionTabsCount.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    actions
};
